import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';

export const processText = (text?: string) => {
  const s = document.createElement('span');
  s.innerHTML = text || '';
  return s.innerText;
};

export const platformText = (signal: MarketSignal) => {
  switch (signal.sourcePlatform) {
    case 'twitter/x':
      return ' on X (Twitter)';
    case 'truth-social':
      return ' on Truth Social';
    case 'website':
      return ' (from Website)';
    case 'linkedin':
      return ' on LinkedIn';
    case 'pipeline-notification':
      return ' (from Pipeline Notification)';
    default:
      return '';
  }
};

export const platformPrefix = (signal: MarketSignal) => {
  switch (signal.sourcePlatform) {
    case 'truth-social':
      return '{us} ';
    default:
      return '';
  }
};

export const copyText = (signal: MarketSignal) => {
  const sourceNames = signal.infoSources.map(s => s.name).join(', ');

  return `${platformPrefix(signal)}${sourceNames}${platformText(signal)}:
        
${processText(signal.headline)}

${processText(signal.summary)}

${processText(signal.body)}`.trim();
};
